import * as React from 'react';
export default function SvgWifiNoConnection() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.5 14.563a4.231 4.231 0 012.5-.813c.934 0 1.798.302 2.5.813M16.713 11.228a8.213 8.213 0 00-2.534-1.187m-6.891 1.187a8.206 8.206 0 013.058-1.312M4.75 8.25C6.734 6.866 9 5.75 12 5.75c.688 0 1.336.059 1.952.166M19.25 8.25a17.161 17.161 0 00-1.915-1.171M18.25 5.75l-11.5 11.5"
  }));
}